module.exports = __webpack_public_path__ + "static/womenventures-dedd364ccbf4f52c6a948d3f2e7ce386.png";